export default __webpack_public_path__ + "static/media/history-mobile-1.f81c430a.png";